import styled, { css } from 'styled-components'
import { Breakpoint, rem, BaseColor, breakpointStarting, spacing, Typography, themeColor } from '~theme'

export const TableHeader = styled.div`
  ${Typography.titleMedium};
  color: ${themeColor(BaseColor.shade_60)};

  min-width: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${spacing(1)};
`

export const SearchRow = styled.div`
  flex-grow: 1;
  display: flex;
  width: 100%;
  margin-top: ${spacing(0.5)};

  & > div {
    background-color: ${themeColor(BaseColor.shade_0)};
    color: ${themeColor(BaseColor.shade_100)};
  }
`

export const TableContainer = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  min-width: 100%;
`

export const Table = styled.table`
  width: 100%;
  border-radius: ${rem(4)};
  border-collapse: separate;
  border-spacing: 0;
`

export const Tr = styled.tr`
  ${Typography.bodySmall};
`

const Cell = css`
  padding: ${spacing(0.75)} ${spacing(0.5)};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  &:first-of-type {
    padding-left: ${spacing()};
    text-align: left;

    @media (${breakpointStarting(Breakpoint.lg)}) {
      padding-left: ${spacing(2)};
    }
  }

  &:last-of-type {
    padding-right: ${spacing()};

    @media (${breakpointStarting(Breakpoint.lg)}) {
      padding-right: ${spacing(2)};
    }
  }

  //Last column is always aligned to right
  &:nth-child(n + 3):last-of-type {
    text-align: right;
  }
`

export const Th = styled.th`
  ${Cell};
  padding-top: ${spacing(1)};
  padding-bottom: ${spacing(1)};
  color: ${themeColor(BaseColor.shade_90)};

  &:last-of-type {
    border-top-right-radius: ${rem(4)};
  }
  &:first-of-type {
    border-top-left-radius: ${rem(4)};
  }
`

export const Td = styled.td`
  ${Cell};
  font-feature-settings: 'calt' 0;
  color: ${themeColor(BaseColor.shade_60)};
  border-bottom: 1px solid ${themeColor(BaseColor.shade_20)};
`

export const THead = styled.thead`
  text-align: left;

  & th {
    background: ${themeColor(BaseColor.shade_20)};

    &:last-of-type {
      border-top-right-radius: ${rem(4)};
    }

    &:first-of-type {
      border-top-left-radius: ${rem(4)};
    }
  }
`

export const TBody = styled.tbody`
  background: transparent;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  border-bottom-right-radius: ${rem(4)};
  border-bottom-left-radius: ${rem(4)};

  & > tr {
    &:last-of-type {
      border-bottom-right-radius: ${rem(4)};
      border-bottom-left-radius: ${rem(4)};
      border-bottom: 0;

      & > td {
        &:last-of-type {
          border-bottom-right-radius: ${rem(4)};
        }

        &:first-of-type {
          border-bottom-left-radius: ${rem(4)};
        }
      }
    }
  }
`

export const PaginationContainer = styled.div`
  min-height: 0;
  min-width: 100%;
  margin-top: ${spacing(1.5)};
`
